import * as React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { Button } from '~features/ui';

import { Token } from '../../../types';

const getLPUrl = (tokenAddress: string, secondTokenAddress: string) =>
  `https://pancakeswap.finance/v2/add/${tokenAddress}/${secondTokenAddress}`;

export function LiquidityProvideLink({
  mainToken,
  secondToken,
  url,
}: {
  mainToken: Token;
  secondToken: Token;
  url?: string;
}) {
  return (
    <Button
      href={
        url ||
        getLPUrl(mainToken.address, secondToken.address || secondToken.symbol)
      }
      target="_blank"
      className="flex items-center space-x-2"
      size="sm">
      <span>Add to LP</span>
      <FaExternalLinkAlt className="inline-block" />
    </Button>
  );
}
